module.exports = __webpack_public_path__ + "static/media/serachmyellow.980c7ea7.svg";